import { render, staticRenderFns } from "./DocumentCreate.vue?vue&type=template&id=af20ec5c&scoped=true"
import script from "./DocumentCreate.vue?vue&type=script&lang=js"
export * from "./DocumentCreate.vue?vue&type=script&lang=js"
import style0 from "./DocumentCreate.vue?vue&type=style&index=0&id=af20ec5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af20ec5c",
  null
  
)

export default component.exports